import type { Dict } from "./fr";

export const nl: Dict = {
  nav: {
    services: "Diensten",
    references: "Referenties",
    about: "Over ons",
    faq: "FAQ",
    tools: "Tools",
    contact: "Contact",
    cta: "Afspraak maken",
  },
  common: {
    available: "Beschikbaar voor nieuwe opdrachten Q2 2026",
    learnMore: "Meer weten",
    discoverServices: "Ontdek onze diensten",
    bookCall: "Plan een gesprek",
    bookSlot: "Reserveer een tijdslot",
    talk: "Bespreek uw behoefte",
    seeAllRefs: "Alle referenties bekijken",
    moreAboutAlex: "Meer over Alexandre",
    followLinkedIn: "Volg Alexandre op LinkedIn",
    sendEmail: "Stuur een e-mail",
    call: "Bellen",
    send: "Versturen",
  },
  breadcrumb: {
    home: "Home",
  },
  home: {
    title: "Hotelconsultant · Opening & beheer | 2AM Hospitality",
    description:
      "Onafhankelijke hotelconsultant in België & Luxemburg: opening, pre-opening, beheer, short-stay en hybride hospitality.",
    heroTitlePre: "Hospitality, ",
    heroTitleAccent: "gestructureerd.",
    heroTitlePost: "\nHotelconsultant & exploitant — opening, beheer en hotelmanagement.",
    heroSub:
      "Onafhankelijk hotelconsultingbureau in Brussel. We begeleiden onafhankelijke hotels, boutiquehotels en hybride concepten in België en Luxemburg — van pre-opening tot dagelijkse optimalisatie.",
    seoLead:
      "Onafhankelijke hotelconsultant — opening, pre-opening, management en exploitatie. Short-stay exploitant en hybride hospitality in België en Luxemburg.",
    stats: [
      { v: "15+", l: "jaar ervaring" },
      { v: "40+", l: "ondersteunde etablissementen" },
      { v: "2", l: "landen (België & Luxemburg)" },
      { v: "100%", l: "onafhankelijk" },
    ],
    statsSubtext: [
      "in operationeel hotelbeheer",
      "van 15 tot 450 kamers, BE & LU",
      "België & Luxemburg",
      "sinds 2022",
    ],
    offersTitle: "Drie pijlers van begeleiding",
    offersSub: "Een volledig spectrum, van eenmalig tot operationeel.",
    offers: [
      {
        title: "Operationeel beheer",
        desc: "Dagelijkse exploitatie, pre-opening en opening. Aansturing op locatie of op afstand, standaarden, teams en processen.",
        tags: ["Pre-opening", "Opening", "Exploitatie"],
      },
      {
        title: "Gerichte consulting",
        desc: "Flash audits en gerichte opdrachten om uw operaties te verbeteren: diagnose, concreet actieplan, gemeten resultaten.",
        tags: ["Audit", "Actieplan", "ROI"],
      },
      {
        title: "Vergunningen, IT & automatisering",
        desc: "Exploitatievergunningen, hotel-IT-infrastructuur en procesautomatisering. De technische expertise die uw teams ontlast.",
        tags: ["Vergunningen", "Hotel-IT", "Automatisering"],
      },
    ],
    methodTitle: "Een heldere methode, meetbare resultaten.",
    method: [
      { t: "Luisteren", d: "We begrijpen uw context, beperkingen en doelen." },
      { t: "Diagnose", d: "Operationele, financiële en technische audit. Cijfers en feiten." },
      { t: "Handelen", d: "Geprioriteerd actieplan. Uitvoering ter plaatse of teambegeleiding." },
      { t: "Meten", d: "Heldere KPI's, regelmatige rapportering, continue bijsturing." },
    ],
    forWhoTitle: "Met wie werken we?",
    forWho: [
      "Onafhankelijke hotels",
      "Boutiquehotels",
      "Kleine hotelgroepen in structurering",
      "Short-stay en short-stay exploitatie",
      "Hybride hospitality (aparthotel, coliving-hotel)",
      "Van economy tot belevingsgericht",
    ],
    refsTitle: "Vertrouwd door",
    aboutTeaserTitle: "10 jaar op de werkvloer. Niet in de vergaderzaal.",
    aboutTeaser:
      "Wij hebben 10 jaar lang hotels gestructureerd, geopend en omgeturnd. Met 2AM Hospitality stelt hij die expertise ten dienste van operatoren die concrete, meetbare en onafhankelijke resultaten willen.",
    finalTitle: "Een project, een vraag, een audit?",
    finalSub: "30 minuten kennismakingsgesprek, vrijblijvend.",
    manifestoTitle: ["Wanneer de lobby ", "stil wordt,", "zijn wij wakker."],
    manifestoDesc:
      "2AM is het uur waarop de nachtauditeur de boeken sluit en de gasten slapen. \nHet is ook het uur waarop elke operationele beslissing kan worden genomen — in omzet, in gastervaring, in marge.",
    readMore: "Lees het hele verhaal",
  },
  services: {
    title: "Diensten hotelconsultant — België & Luxemburg",
    description:
      "Hotelopening & pre-opening, beheer, short-stay en hybride hospitality. Vergunningen en hotel-IT in België & Luxemburg.",
    h1: "Hotelconsultant & exploitant: opening, pre-opening, beheer en hotelmanagement",
    sub: "Drie pijlers, één methode, meetbare resultaten.",
    tldr: "In één zin: 2AM Hospitality is een Belgisch hotelconsulting- en exploitatiebureau, gespecialiseerd in opening, pre-opening, beheer en management van hotels — inclusief short-stay en hybride hospitality in België en Luxemburg.",
    tldrLabel: "In één zin",
    modality: "Modaliteiten",
    modalityValue: "Vaste prijs, regie of maandelijkse retainer.",
    forWho: "Voor wie?",
    concretely: "Wat we concreet doen",
    whyTitle: "Waarom 2AM?",
    why: [
      { e: "🎯", t: "Eerst het terrein", d: "We hebben hotels uitgebaat, niet alleen geadviseerd." },
      { e: "📊", t: "Cijfers & deliverables", d: "Geen deck — concrete KPI's en acties." },
      { e: "⚙️", t: "Dubbele cultuur", d: "Exploitatie + tech + vergunningen onder één dak." },
      { e: "📍", t: "Verankerd in België", d: "Kennis van de markt, regelgeving en lokale spelers." },
    ],
    tableTitle: "Vergelijking van de drie aanbiedingen",
    tableHeaders: ["", "Operationeel beheer", "Gerichte consulting", "Vergunningen & IT"],
    tableRows: [
      { l: "Typische duur", v: ["3 tot 12 maanden", "2 tot 30 dagen", "1 tot 6 maanden"] },
      { l: "Formaat", v: ["Vaste prijs of retainer", "Vaste prijs", "Vaste prijs of regie"] },
      { l: "Opleveringen", v: ["KPI-rapportering, SOP's, standaarden", "Geprioriteerd actieplan", "Vergunningsdossier, IT-stack"] },
      { l: "Ideaal voor", v: ["Pre-opening, overname, continue verbetering", "Flash diagnose, herstel", "Nieuwe openingen, IT-herinrichting"] },
    ],
    miniFaqTitle: "Veelgestelde vragen over onze diensten",
    miniFaq: [
      {
        q: "Wat is het verschil tussen een flash audit en operationele begeleiding?",
        a: "De flash audit (2-5 dagen) levert een becijferde diagnose en actieplan. Operationele begeleiding is de uitvoering van dat plan, over meerdere maanden, op locatie of op afstand.",
      },
      {
        q: "Kan ik meerdere diensten combineren?",
        a: "Ja. De meeste opdrachten combineren een initiële audit (gerichte consulting) met uitvoeringsbegeleiding (operationeel beheer). Scope na een eerste scopinggesprek.",
      },
      {
        q: "Werken jullie alleen in België?",
        a: "België en Luxemburg zijn onze kernmarkten. We accepteren punctuele opdrachten in de rest van Europa op basis van beschikbaarheid.",
      },
    ],
    faqLinkTitle: "Andere vragen?",
    faqLinkText: "Tarieven, doorlooptijden, modaliteiten: lees onze volledige FAQ.",
    faqLinkCta: "FAQ raadplegen",
    shortStayTitle: "Short-stay exploitant & consultant · hybride hospitality",
    shortStayDesc:
      "Naast het klassieke hotel begeleiden we short-stay exploitanten (korte verblijven, aparthotels) en hybride hospitality concepten (coliving-hotel, aparthotel-coworking). Structurering van de exploitatie, Belgische regelgevingsconformiteit, PMS-stack op maat van langere verblijven en automatisering van het gasttraject zonder 24/7 receptie.",
    shortStayBullets: [
      "Short-stay exploitant: processen, lean teams, multi-channel distributie",
      "Hybride hospitality: aparthotel, coliving-hotel, hotel-coworking modellen",
      "Short-stay specifieke conformiteit (Brussel, Wallonië, Vlaanderen, Luxemburg)",
      "Automatisering: online check-in, slimme sloten, digitale conciërge",
    ],
    items: [
      {
        id: "operations",
        num: "01",
        title: "Operationeel beheer",
        intro:
          "Van pre-opening tot dagelijkse operationele aansturing. Aanwezigheid ter plaatse of management op afstand.",
        tldr:
          "In één zin: wij verzorgen de pre-opening en het operationele management van onafhankelijke hotels, boutiquehotels en kleine groepen in België & Luxemburg, ter plaatse of op afstand, met SOP's, KPI-rapportering en team-aansturing.",
        bullets: [
          "Pre-opening: planning, rekrutering, opleiding, aankopen",
          "Aansturing van de opening (soft opening + grand opening)",
          "Interim-operationeel management",
          "Standaarden en SOP's",
          "Opzet van dagelijkse operationele rapportering",
          "Team- en shiftbeheer",
          "Coördinatie met partners (wasserij, F&B, onderhoud)",
        ],
        tags: ["Onafhankelijke hotels", "Boutiquehotels", "Kleine groepen"],
      },
      {
        id: "consulting",
        num: "02",
        title: "Gerichte consulting voor operationele verbetering",
        intro:
          "Een korte, gerichte, becijferde opdracht. Diagnose ter plaatse, geprioriteerd actieplan, KPI's.",
        tldr:
          "In één zin: een flash-audit van 2 tot 5 dagen ter plaatse met financiële diagnose, mystery visit en becijferd geprioriteerd actieplan om een operationeel hotel te herstellen of te optimaliseren, vanaf € 4.500 excl. btw.",
        bullets: [
          "Flash operationele audit (2-5 dagen ter plaatse)",
          "Financiële diagnose en benchmarking",
          "Front-office en housekeeping procesreview",
          "Geprioriteerd actieplan met KPI's",
          "Mystery visit en gastreis-analyse",
          "Aanbevelingen distributie en revenue management",
          "Maandelijkse uitvoeringsopvolging (optioneel)",
        ],
        tags: ["Operationele hotels", "Groepen in structurering"],
      },
      {
        id: "tech",
        num: "03",
        title: "Gerichte consulting: vergunningen, IT & automatisering",
        intro:
          "De technische expertise die teams ontlast: regelgeving, moderne IT-stack, automatisering van flows.",
        tldr:
          "In één zin: wij dienen exploitatievergunningen BE/LU in, selecteren en integreren de PMS-stack (Mews, Cloudbeds, Misterbooking, Hotellab) en automatiseren check-in, slimme sloten en digitale conciërge voor openingen en hybride concepten.",
        bullets: [
          "Aanvraag en hernieuwing exploitatievergunning",
          "Controle van de wettelijke conformiteit",
          "Audit en herinrichting hotel-IT (PMS, channel manager, wifi, TV, slimme sloten)",
          "Selectie en integratie van de juiste tech stack (PMS & globale IT-suite)",
          "Automatisering: online check-in, upsell, digitale conciërge, boekhoudkoppelingen",
        ],
        tags: ["Pre-opening", "Hotels in transformatie", "Hybride concepten"],
      },
    ],
  },
  references: {
    title: "Referenties hotelconsultant — 2AM Hospitality",
    description:
      "Hotelconsultant-opdrachten in België: openingen, exploitatie, short-stay en hybride hospitality. Boutiquehotels en aparthotels.",
    h1: "Opdrachten: hotelopening, pre-opening, beheer en hotelmanagement",
    sub: "Recente opdrachten",
    typesTitle: "Types ondersteunde etablissementen",
    types: [
      "Onafhankelijke hotels",
      "Boutiquehotels",
      "Economy-groepen",
      "Short-stay & aparthotels",
      "Hybride concepten",
    ],
    items: [
      {
        type: "Boutiquehotel 4★ · 45 kamers · Brussel",
        mission: "Pre-opening begeleiding",
        duration: "6 maanden · 2024-2025",
        results: [
          "Volledige rekrutering en opleiding van het team",
          "PMS en distributie-stack opzetten",
          "Tijdige opening met TripAdvisor 4.7 vanaf de eerste maand",
        ],
        tag: "Operaties",
      },
      {
        type: "Groep van 3 hotels · Luxemburg",
        mission: "Operationele audit & actieplan",
        duration: "3 maanden · 2024",
        results: [
          "Diagnose ter plaatse op 3 sites",
          "Geprioriteerd actieplan op 12 hefbomen",
          "+11 ppt bruto operationele marge in 6 maanden",
        ],
        tag: "Consulting",
      },
      {
        type: "Hybride aparthotel · België",
        mission: "IT-herinrichting & automatisering",
        duration: "4 maanden · 2025",
        results: [
          "Migratie naar moderne cloud-PMS-stack",
          "100% online check-in + slimme sloten",
          "−40% administratieve tijd per verblijf",
        ],
        tag: "Tech",
      },
    ],
    cta: "Wilt u erover praten?",
  },
  about: {
    title: "Over ons · Alexandre Dufrene — 2AM Hospitality",
    description:
      "Alexandre Dufrene, oprichter van 2AM Hospitality. 15 jaar hoteloperaties (B&B HOTELS, ACCOR) ten dienste van operatoren.",
    h1: "15 jaar op de werkvloer. Niet in de vergaderzaal.",
    sub: "Alexandre Dufrene — hotelconsultant, short-stay exploitant en hybride hospitality expert in België & Luxemburg.",
    bio: "Na meerdere jaren openingen en overnames van hotels te leiden voor B&B HOTELS en onafhankelijke groepen, richtte Alexandre Dufrene in 2022 2AM Hospitality op met één overtuiging: onafhankelijke hoteliers verdienen even rigoureuze begeleiding als die van de grote groepen, zonder de bureaucratie. \n\nZijn dubbele cultuur — exploitatie op het terrein en portefeuille-ontwikkeling — laat hem even vlot praten met receptieteams als met investeerders en eigenaars. \n\n10 jaar op de werkvloer. Meetbare resultaten.",
    tldr: "In één zin: Alexandre Dufrene, oprichter van 2AM Hospitality, is hotelconsultant en short-stay & hybride hospitality exploitant, ex-B&B HOTELS en Accor, expert in PMS Mews, Cloudbeds en Misterbooking in België & Luxemburg.",
    servicesCtaTitle: "Wilt u zien hoe we werken?",
    servicesCta: "Ontdek onze diensten",
    journeyTitle: "Traject",
    journey: [
      { y: "2022", t: "Oprichting van 2AM Hospitality" },
      { y: "2019-2022", t: "Multi-site operaties · B&B HOTELS" },
      { y: "2009-2019", t: "Hotelmanagement · onafhankelijke groepen" },
    ],
    whyTitle: "Waarom 2AM?",
    why: "2AM is het uur waarop een hotel zonder filter leeft, waar iedereen slaapt maar waar alles zich afspeelt. \n\nHet is door anticipatie dat de operationele kwaliteit echt wordt gemeten.",
    valuesTitle: "Waarden",
    values: [
      { t: "Concreet", d: "Terrein, cijfers, deliverables. Geen lege slides." },
      { t: "Smart", d: "Automatisering van taken om meer tijd vrij te maken voor waardevolle activiteiten van teams" },
      { t: "Meetbaar", d: "KPI's vooraf bepaald, achteraf gemeten." },
    ],
  },
  faq: {
    title: "FAQ hotelconsultant — België & Luxemburg",
    description:
      "Veelgestelde vragen over hotelconsulting in België en Luxemburg.",
    h1: "FAQ — hotelconsultant, opening & exploitatie",
    glossaryTitle: "Woordenlijst — kernbegrippen",
    glossary: [
      { term: "Hybride hospitality", def: "Concept dat hotel, aparthotel, coliving of coworking onder één dak combineert. Beperkte receptie, korte of lange verblijven, volledig digitale klantreis." },
      { term: "Short-stay", def: "Exploitatie van gemeubileerde accommodaties voor korte verblijven (1 tot 30 nachten), als aanvulling of alternatief voor klassieke hotels. Specifieke regelgeving in Brussel, Wallonië, Vlaanderen en Luxemburg." },
      { term: "Pre-opening", def: "Periode van 6 tot 12 maanden vóór de commerciële opening van een hotel: rekrutering, opleiding, aankopen, PMS-installatie, soft opening." },
      { term: "PMS (Property Management System)", def: "Centrale exploitatiesoftware (reserveringen, check-in, facturatie, rapportering). Voorbeelden: Mews, Cloudbeds, Misterbooking, Apaleo, Opera Cloud." },
    ],
    items: [
      {
        q: "Wat is uw werkgebied?",
        a: "Voornamelijk België en Luxemburg, met af en toe verplaatsingen in Europa. Vanuit Incourt werken we vaak in Brussel, Antwerpen, Gent, Luik en Luxemburg-Stad.",
      },
      {
        q: "Wat kost een typische opdracht?",
        a: "Een flash audit start vanaf € 4.500 (2 tot 5 dagen). Pre-opening tussen € 25.000 en € 80.000 afhankelijk van de scope. Maandelijkse retainer: € 2.500 tot € 6.000/maand. Offerte op maat na scoping.",
      },
      {
        q: "Werkt u op vaste prijs of in regie?",
        a: "Beide. Vaste prijs voor afgebakende opdrachten (audits, openings), regie voor interim management of evolutieve behoeften. Maandelijkse retainer voor continue opvolging.",
      },
      {
        q: "Bieden jullie interim-management aan?",
        a: "Ja, hoteldirectie of multi-site operationele directie, voor 1 tot 6 maanden.",
      },
      {
        q: "Wat is de minimum duur van een opdracht?",
        a: "2 dagen voor een flash audit. Geen maximum.",
      },
      {
        q: "Hoe verloopt een pre-opening opdracht?",
        a: "Initiële scoping, gedetailleerd plan D-180 tot D+30, rekrutering, opleiding, processen, soft opening, grand opening, daarna gestructureerde overdracht.",
      },
      {
        q: "Werken jullie met onafhankelijken of enkel met groepen?",
        a: "Beide. Onze kerndoelgroep: onafhankelijken, boutiquehotels en kleine groepen in structurering. Van economy tot belevingsgericht.",
      },
      {
        q: "Heeft u expertise rond exploitatievergunningen in België en Luxemburg?",
        a: "Ja: exploitatievergunningen, brandveiligheid, FAVV, stedenbouw, gemeentelijke aangiften. We werken samen met gespecialiseerde advocaten voor complexe dossiers.",
      },
      {
        q: "Welke PMS-systemen kennen jullie?",
        a: "Mews, Cloudbeds, Hotellab, Apaleo, Opera Cloud, Misterbooking, plus channel managers (SiteMinder, D-EDGE, Cubilis) en revenue management tools.",
      },
      {
        q: "Hoe starten we een samenwerking?",
        a: "Een kennismakingsgesprek van 30 minuten (gratis, vrijblijvend) via Calendly, of een mail naar hello@2amhospitality.com. Antwoord binnen 48u met scope en voorstel.",
      },
      {
        q: "Begeleiden jullie short-stay en hybride hospitality projecten?",
        a: "Ja. We werken met short-stay exploitanten (korte verblijven, aparthotels) en hybride hospitality concepten (coliving-hotel, aparthotel-coworking): structurering van de exploitatie, Belgische en Luxemburgse regelgevingsconformiteit, PMS-stack op maat, automatisering van het gasttraject (online check-in, slimme sloten).",
      },
      {
        q: "Wat is het verschil tussen een hotelconsultant en een hotelexploitant?",
        a: "Een hotelconsultant adviseert, audit en structureert; een hotelexploitant runt het hotel dagelijks. 2AM Hospitality combineert beide: we hebben 10 jaar hotels uitgebaat voor we adviseerden — vandaar aanbevelingen die direct toepasbaar zijn op de werkvloer en de mogelijkheid om interim operationele leiding te nemen.",
      },
    ],
  },
  contact: {
    title: "Contact 2AM Hospitality — hotelconsultant",
    description: "Contacteer 2AM Hospitality: afspraak, e-mail, telefoon. Brussel · België · Luxemburg.",
    h1: "Laten we praten.",
    sub: "Laten we uw project bespreken: hotelopening, management, short-stay exploitatie of hybride hospitality.",
    bookTitle: "Afspraak maken",
    bookDesc: "Reserveer rechtstreeks een tijdslot van 30 min.",
    emailTitle: "E-mail",
    phoneTitle: "Telefoon",
    formTitle: "Of stuur ons een bericht",
    faqLinkText: "Vragen voor u contact opneemt?",
    faqLinkCta: "FAQ raadplegen",
    responseGuarantee: "Antwoord gegarandeerd binnen 24 werkuren",
    fields: {
      name: "Volledige naam",
      email: "E-mail",
      company: "Bedrijf / project",
      type: "Type aanvraag",
      typeOptions: ["Operaties", "Gerichte consulting", "Tech & Vergunningen", "Andere"],
      message: "Bericht",
      gdpr: "Ik aanvaard dat mijn gegevens gebruikt worden om mijn aanvraag te beantwoorden.",
    },
    success: "Bedankt, uw bericht is verstuurd.",
  },
  footer: {
    pitch: "Hotelconsultingbureau. België & Luxemburg. Onafhankelijk, terreingericht, meetbaar.",
    nav: "Navigatie",
    services: "Diensten",
    contact: "Contact",
    legal: "Wettelijke vermeldingen",
    privacy: "Privacybeleid",
    cookies: "Cookies",
    rights: "Alle rechten voorbehouden.",
  },
  related: {
    eyebrow: "Verder ontdekken",
    title: "Ga dieper",
    cta: "Ontdekken",
    cards: {
      services: {
        title: "Hotelconsultant-diensten",
        desc: "Opening, beheer, exploitatie en hybride hospitality.",
      },
      references: {
        title: "Recente opdrachten",
        desc: "Concrete cases: openingen, audits, exploitatie, short-stay.",
      },
      about: {
        title: "De oprichter",
        desc: "Alexandre Dufrene — 10 jaar hotelexploitatie in België.",
      },
      faq: {
        title: "FAQ",
        desc: "Tarieven, doorlooptijden, scope, ondersteunde PMS: alle antwoorden.",
      },
      tools: {
        title: "Hoteltools",
        desc: "Gratis calculators en bronnen voor hoteloperatoren.",
      },
      contact: {
        title: "Contact & afspraak",
        desc: "30-min kennismakingsgesprek, e-mail of telefoon — antwoord binnen 24u.",
      },
    },
  },
  cookies: {
    banner: {
      title: "Uw cookievoorkeuren",
      body: "We gebruiken cookies om de site te laten werken en, met uw toestemming, om het gebruik te meten. U kunt op elk moment aanvaarden, weigeren of aanpassen.",
      learnMore: "Meer info",
      acceptAll: "Alles aanvaarden",
      rejectAll: "Alles weigeren",
      customize: "Aanpassen",
    },
    prefs: {
      title: "Cookievoorkeuren",
      subtitle: "Kies welke categorieën u toestaat.",
      save: "Mijn keuzes opslaan",
      close: "Sluiten",
    },
    cats: {
      necessary: {
        title: "Strikt noodzakelijk",
        desc: "Vereist voor de werking van de site (beveiliging, taalvoorkeur, navigatie). Altijd actief.",
      },
      analytics: {
        title: "Bezoekersmeting",
        desc: "Anonieme statistieken (Google Analytics) om het gebruik van de site te begrijpen en te verbeteren.",
      },
      marketing: {
        title: "Marketing",
        desc: "Advertentie- of social-mediacookies. Momenteel geen actief — voorbehouden voor toekomstig gebruik.",
      },
    },
    page: {
      eyebrow: "Cookiebeleid",
      title: "Cookiebeleid",
      intro:
        "Deze pagina legt uit welke cookies en gelijkaardige technologieën worden gebruikt op 2amhospitality.com en hoe u uw voorkeuren op elk moment kunt beheren.",
      manageTitle: "Mijn voorkeuren beheren",
      manageBody: "U kunt uw keuzes op elk moment wijzigen. Het voorkeurenvenster wordt opnieuw geopend.",
      manageCta: "Voorkeuren bijwerken",
      sections: [
        {
          title: "Wat is een cookie?",
          body: "Een cookie is een klein tekstbestand dat op uw apparaat wordt geplaatst bij een bezoek aan een website. Het kan uw taal onthouden, een sessie beveiligen of het gebruik van de site meten.",
        },
        {
          title: "Strikt noodzakelijke cookies",
          body: "Deze cookies zijn essentieel: taalvoorkeur, beveiliging, load balancing. Ze vereisen geen toestemming en kunnen niet worden uitgeschakeld.",
        },
        {
          title: "Cookies voor bezoekersmeting",
          body: "Met uw toestemming gebruiken we Google Analytics om bezoeken op anonieme wijze te meten (anoniem IP, geen kruisverwijzing met andere diensten). Dit helpt ons inhoud en gebruiksgemak te verbeteren.",
        },
        {
          title: "Marketingcookies",
          body: "Vandaag worden er geen advertentiecookies geplaatst. Deze categorie is voorbehouden voor toekomstig gebruik (bv. een LinkedIn-pixel) en blijft uit tot u dit expliciet toestaat.",
        },
        {
          title: "Bewaartermijn",
          body: "Uw toestemmingskeuze wordt 12 maanden in uw browser bewaard. Daarna verschijnt het toestemmingsvenster opnieuw.",
        },
        {
          title: "Uw rechten",
          body: "Op basis van de AVG heeft u recht op inzage, rectificatie, verwijdering en bezwaar. Om deze rechten uit te oefenen kunt u contact opnemen via hello@2amhospitality.com.",
        },
      ],
    },
  },
  tools: {
    title: "Hoteltools — 2AM Hospitality",
    description:
      "Ontdek de tools en platformen die door 2AM Hospitality worden ontwikkeld of ondersteund: Onerly, Maintel.io, Groupsmadeeasy.",
    eyebrow: "Tools",
    h1: "Tools van een hotelconsultant & exploitant",
    sub: "Platformen die we ontwikkelen of ondersteunen voor hotelopening, hotelmanagement, short-stay en hybride hospitality.",
    statusLive: "Online",
    statusWip: "In ontwikkeling",
    visit: "Bezoek de site",
    wipNote: "Binnenkort beschikbaar",
    items: [
      {
        name: "Onerly",
        tagline: "​",
        description:
          "Platform dat de hotelprojecten en onafhankelijke concepten in de kijker zet die we begeleiden.",
        status: "live",
        url: "#",
      },
      {
        name: "Maintel.io",
        tagline: "​",
        description:
          "Oplossing voor technisch beheer en onderhoud, ontworpen voor veeleisende hotelactiviteiten.",
        status: "live",
        url: "#",
      },
      {
        name: "Groupsmadeeasy",
        tagline: "Momenteel in ontwikkeling",
        description:
          "Tool voor het beheer van groepsreserveringen voor hoteliers, momenteel in ontwerp. Lancering binnenkort.",
        status: "wip",
        url: "#",
      },
    ],
  },
  legal: {
    page: {
      eyebrow: "Wettelijke vermeldingen",
      title: "Wettelijke vermeldingen",
      intro:
        "Wettelijke informatie over de uitgever, de hosting en het gebruik van de website 2amhospitality.com.",
      sections: [
        {
          title: "Uitgever",
          body: "2AM Hospitality\nOprichter: Alexandre Dufrene\nRue du Pachy 6, 1315 Incourt, België\nEmail: hello@2amhospitality.com\nTelefoon: +32 479 89 52 15",
        },
        {
          title: "Verantwoordelijke uitgever",
          body: "Alexandre Dufrene, oprichter van 2AM Hospitality.",
        },
        {
          title: "Hosting",
          body: "De website wordt gehost op edge cloud-infrastructuur (Cloudflare Workers). Applicatiegegevens worden gehost op de infrastructuur van Supabase (Europese Unie).",
        },
        {
          title: "Intellectuele eigendom",
          body: "Alle inhoud op deze site (teksten, afbeeldingen, logo's, merken, structuur) is exclusief eigendom van 2AM Hospitality, tenzij anders vermeld. Elke gehele of gedeeltelijke reproductie, weergave, wijziging of verspreiding zonder voorafgaande schriftelijke toestemming is verboden.",
        },
        {
          title: "Aansprakelijkheid",
          body: "2AM Hospitality streeft ernaar de juistheid en actualiteit van de op deze site gepubliceerde informatie te garanderen, zonder de volledigheid ervan te kunnen waarborgen. De gebruiker erkent deze informatie op eigen verantwoordelijkheid te gebruiken.",
        },
        {
          title: "Externe links",
          body: "De site kan links bevatten naar websites van derden. 2AM Hospitality heeft geen controle over deze sites en wijst alle verantwoordelijkheid voor hun inhoud af.",
        },
        {
          title: "Toepasselijk recht",
          body: "Deze wettelijke vermeldingen worden beheerst door het Belgische recht. Elk geschil met betrekking tot de site valt onder de exclusieve bevoegdheid van de rechtbanken van Brussel.",
        },
        {
          title: "Contact",
          body: "Voor vragen over de site of deze wettelijke vermeldingen: hello@2amhospitality.com",
        },
      ],
    },
  },
  privacy: {
    page: {
      eyebrow: "Privacy",
      title: "Privacybeleid",
      intro:
        "Dit beleid beschrijft hoe 2AM Hospitality uw persoonsgegevens verzamelt, gebruikt en beschermt, in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).",
      sections: [
        {
          title: "Verwerkingsverantwoordelijke",
          body: "2AM Hospitality\nRue du Pachy 6, 1315 Incourt, België\nContact: hello@2amhospitality.com",
        },
        {
          title: "Verzamelde gegevens",
          body: "We verzamelen de gegevens die u via het contactformulier verstrekt (naam, e-mail, bedrijf, type aanvraag, bericht) evenals geanonimiseerde technische surfgegevens (met uw toestemming, via Google Analytics).",
        },
        {
          title: "Doeleinden van de verwerking",
          body: "Uw gegevens worden gebruikt om: te reageren op uw aanvragen, een gesprek of afspraak te organiseren, onze commerciële relatie op te volgen, het sitegebruik te meten (anonieme statistieken) en te voldoen aan onze wettelijke verplichtingen.",
        },
        {
          title: "Rechtsgrond",
          body: "De verwerking is gebaseerd op uw toestemming (formulier, analyticscookies), de uitvoering van precontractuele maatregelen op uw verzoek en ons gerechtvaardigd belang om onze activiteit te ontwikkelen.",
        },
        {
          title: "Bewaartermijn",
          body: "Berichten via het formulier worden 3 jaar bewaard vanaf het laatste contact. Analyticsgegevens worden maximaal 14 maanden bewaard. Cookietoestemming wordt 12 maanden bewaard.",
        },
        {
          title: "Ontvangers",
          body: "Uw gegevens zijn alleen toegankelijk voor 2AM Hospitality. Ze kunnen worden verwerkt door onze technische subverwerkers (hosting Supabase, e-mailverzending Resend, meting Google Analytics), die contractueel verplicht zijn de AVG na te leven.",
        },
        {
          title: "Doorgifte buiten de EU",
          body: "Sommige subverwerkers (Google Analytics) kunnen doorgiften buiten de Europese Unie inhouden, geregeld door de modelcontractbepalingen van de Europese Commissie.",
        },
        {
          title: "Uw rechten",
          body: "Op basis van de AVG heeft u de volgende rechten: inzage, rectificatie, wissing, beperking, bezwaar, overdraagbaarheid en intrekking van toestemming op elk moment. Om deze rechten uit te oefenen: hello@2amhospitality.com.",
        },
        {
          title: "Klacht",
          body: "U kunt een klacht indienen bij de Belgische Gegevensbeschermingsautoriteit (GBA): www.gegevensbeschermingsautoriteit.be",
        },
        {
          title: "Beveiliging",
          body: "We implementeren passende technische en organisatorische maatregelen (TLS-encryptie, toegangscontrole, back-ups) om uw gegevens te beschermen tegen ongeoorloofde toegang, wijziging of vernietiging.",
        },
      ],
    },
  },
  geo: "Actief in Brussel, Antwerpen, Gent, Luik, Namen, Charleroi, Brugge, Leuven, Luxemburg-Stad en Esch-sur-Alzette — overal in België en het Groothertogdom.",
};
